import GedcomX from '../../shared/helpers/gedcom_X'

export default function locatePersonByAtn(treeList, atn) {
  const gcx = GedcomX()
  const convertToInteger = (atnValue) => parseInt(atnValue, 10)
  const filterOutSpouseChildren = (item) => !Number.isNaN(convertToInteger(item.atn))
  const isAtnMatch = (item) => convertToInteger(item.atn) === atn

  const match = treeList.filter(filterOutSpouseChildren).find(isAtnMatch)

  if (match) {
    match.atn = convertToInteger(match.atn)
    match.dob = convertToInteger(match.dob) || null
    match.dod = convertToInteger(match.dod) || null
    match.genderType = match.genderType === gcx.UNKNOWN ? null : match.genderType
  }

  return match
}

export const is3GenInTree = (tree) => {
  let i = 0
  let showATF = false

  const findAtn = (p) => {
    return p.atn === i
  }

  for (i = 1; i < 8; i++) {
    if (!tree.find(findAtn)) {
      showATF = true
      break
    }
  }

  return showATF
}
